import slug from "../slug";

const getFormKey = (index = 1) => {
  const depth = {
    1: 'category',
    2: 'objet',
    3: 'reason',
    4: 'sub_reason',
    5: 'reason_need',
    6: 'sub_reason_need',
  }

  return depth[index]
}

const getCategoryKey = (questionLevel, questionSlug) => {
  const formKey = getFormKey(questionLevel)
  return `${formKey}_${questionSlug}`
}

const buildQuestion = (questionLevel, questionSlug) => {

  const formKey = getFormKey(questionLevel)
  const key = `cf-conditional-${formKey}`
  const value = `${formKey}_${questionSlug}`
  const formFileKey = `${key}_${questionSlug}_forFinishStep`

  return [
    {
      tag: 'input',
      type: 'text',
      name: 'lastname',
      [key]: value,
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'firstname',
      [key]: value,
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'accountNumber',
      [key]: value,
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.',
    },
    {
      tag: 'select',
      type: 'text',
      name: 'clientAgence',
      [key]: value,
      'cf-questions': "Veuillez selectionner l'agence",
      children: [
        {
          tag: 'option',
          'cf-label': 'TMB Place du Marché',
          value: 'TMB Place du Marché',
        },
      ],
    },
    {
      tag: 'input',
      type: 'number',
      name: 'phone',
      [key]: value,
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.',
    },
    {
      tag: 'input',
      type: 'email',
      name: 'email',
      [key]: value,
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'details_de_la_reclamation',
      [key]: value,
      'cf-questions': 'Veuillez fournir des détails sur la réclamation',
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'montant',
      [key]: value,
      'cf-questions': 'Saisissez le montant (ou mettez RAS)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.',
    },
    {
      tag: 'select',
      type: 'text',
      name: `${value}_forFinishStep`,
      [key]: value,
      'cf-questions': 'Avez-vous des fichiers à joindre ? ',
      children: [
        { tag: 'option', 'cf-label': 'Oui', value: 'tmb_bot_upload_file_yes' },
        { tag: 'option', 'cf-label': 'Non', value: 'upload_file_no' },
      ],
    },
    {
      tag: 'input',
      type: 'file',
      multiple: true,
      name: 'files',
      [formFileKey]: 'tmb_bot_upload_file_yes',
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.',
    },
  ]
}

const walkInCategories = (categories, level = 1) => {
  const questions = []

  const magneticFormCategories = [
    'reason_need_atm', 'reason_need_tpe', 'reason_need_en_ligne',
    'sub_reason_rejet_atm', 'sub_reason_rejet_tpe', 'sub_reason_rejet_en_ligne',
    'sub_reason_double_prelevement', 'sub_reason_transaction_non_percue', 'sub_reason_debit_a_tort'
  ]

  for (const category of categories) {
    const slugTitle = slug(category.title)
    const categoryKey = getCategoryKey(level, slugTitle)
    
    if(slugTitle === 'code_swift_inexistant') {
      console.log('code_swift_inexistant !!!!!!!!!!')
      continue
    }

    if(magneticFormCategories.includes(categoryKey)) {
      continue
    }

    if (category.children.length === 0) {
      questions.push(...buildQuestion(level, slugTitle))
    } else {
      questions.push(...walkInCategories(category.children, level + 1))
    }
}
  
  return questions
}

const groupCategoriesByParent = (categories)=> {
  const categoryMap = {};
  const rootCategories = [];

  categories.forEach(category => {
    category.children = [];
    categoryMap[category.id] = category;
  });

  categories.forEach(category => {
    if (category.parent_id === "" || category.parent_id === null) {
      category.parent_id = null;
    }

    if (category.parent_id === null) {
      rootCategories.push(category);
    } else {
      const parent = categoryMap[category.parent_id];
      if (parent) {
        parent.children.push(category);
      }
    }
  });

  return rootCategories;
}


const buildProcess = (categories) => {
  const questions = []

  const magneticFormCategories = [
    'reason_need_atm', 'reason_need_tpe', 'reason_need_en_ligne',
    'sub_reason_rejet_atm', 'sub_reason_rejet_tpe', 'sub_reason_rejet_en_ligne',
    'sub_reason_double_prelevement', 'sub_reason_transaction_non_percue', 'sub_reason_debit_a_tort'
  ]

  let categoryAddedList = []

  for (const category of categories) {
    let level = 0
    if(category.all_parent_id !== undefined) {
      const parentLength = category.all_parent_id.length
      console.log('ooookkkkkk')
      if(parentLength == 0) {
        level = parentLength + 1
      } else {
        level = parentLength
      }
    }
    
    const slugTitle = slug(category.title)
    const categoryKey = getCategoryKey(level, slugTitle)
    if(magneticFormCategories.includes(categoryKey)) {
      continue
    }

    if(!categoryAddedList.includes(categoryKey)) {
      questions.push(...buildQuestion(level, slugTitle))
      categoryAddedList.push(categoryKey)
    }
  }
  
  return questions
}


const createQuestionsPerFlow = (categories) =>  {
  //let rootCategories = groupCategoriesByParent(categories)
  //return walkInCategories(rootCategories)
  
  //console.log(JSON.stringify(buildProcess(categories)))
  console.log('question builder called !!!!!!!!!!!!!!!!!!!!')
  return buildProcess(categories)
}

export default createQuestionsPerFlow